import React, {useEffect, useState} from 'react';
import NavbarLayout from "../shared/components/navbarLayout";
import {useLocation, useNavigate} from "react-router-dom";
import {getName, getRefCount, getRole, getUserId, signOut} from "../shared/utils/SharedAuthentication";
import {useDispatch, useSelector} from "react-redux";
import {toggleChangePassword, toggleLoader, toggleViewVersion} from "../shared/actions/setting";
import {getSelectedCorporate, toggleChangeConfiguration} from '../actions/service';
import packageJson from "../../package.json";
import axios from "axios";
import {toast} from "react-toastify";
import {useTranslation} from 'react-i18next';

export default function Navbar(props) {
  const navigate = useNavigate(); // Use useNavigate instead of useHistory
  const dispatch = useDispatch();
  const location = useLocation();
  const [corporateData, setCorporateData] = useState([]);

  const {t, i18n} = useTranslation();
  const changeLanguage = (language) => {
    i18n.changeLanguage(language);
  };

  function expandPageNotification() {
    navigate("/notification-page"); // Replace history.push with navigate
  }

  function brand() {
    return <span onClick={() => navigate("/")} className={"nav-logo"}>USER MANAGEMENT</span>;
  }

  function about() {
    dispatch(toggleViewVersion(true));
  }

  function showChangePassword() {
    dispatch(toggleChangePassword(true));
  }

  function showChangeConfiguration() {
    dispatch(toggleChangeConfiguration(true));
  }

  function logOut() {
    signOut();
    navigate("/login"); // Replace history.push with navigate
  }

  useEffect(() => {
    dispatch(toggleLoader(true));
    axios.get(process.env.REACT_APP_HOST + `user/` + getUserId() + `/corporate`)
      .then(function (response) {
        setCorporateData(response.data.content);
        if (response.data.content.length > 0) {
          dispatch(getSelectedCorporate(response.data.content[0].id));
        }
      })
      .catch(function (error) {
        if (error.response && error.response.status === 422) {
          toast.error(error.response.data.message);
        }
      }).finally(() => {
      dispatch(toggleLoader(false));
    });
  }, []);

  function setNotifications(notifications) {
    console.log(notifications);
  }

  return (
    <div>
      <NavbarLayout
        notificationDot={false}
        txts={{
          language: "Select Language",
          notifications: "Notifications",
          emptyNotifications: "There are no notifications",
          corporate: "Select Corporate",
        }}
        settingPermission={false}
        notificationCard={() => <div>He</div>}
        setNotifications={setNotifications}
        corporateEnable={true}
        corporateChange={(id) => dispatch(getSelectedCorporate(id))}
        corporateList={corporateData}
        selectedCorporate={useSelector(state => state.serviceList.selectedCorporate)}
        notificationActive={false}
        expandPageNotification={expandPageNotification}
        name={getName()}
        settingList={[]}
        languages={[]}
        hideTranslation={true}
        hideNotification={true}
        changeLanguage={changeLanguage}
        navItems={[
          {
            title: "Dashboard",
            isActive: location.pathname === "/home",
            to: "/home",
            permissions: true,
            webScreen: true,
            icon: "map"
          },
          {
            title: "Roles",
            isActive: location.pathname === "/roles",
            to: "/roles",
            permissions: true,
            webScreen: true,
            icon: "map"
          },
          {
            title: "Privileges",
            isActive: location.pathname === "/privileges",
            to: "/privileges",
            permissions: true,
            webScreen: true,
            icon: "map"
          },
          {
            title: "Accounts",
            isActive: location.pathname === "/accounts",
            to: "/accounts",
            permissions: true,
            webScreen: true,
            icon: "map"
          },
          {
            title: "Corporates",
            isActive: location.pathname === "/corporates",
            to: "/corporates",
            permissions: true,
            webScreen: true,
            icon: "map"
          },
        ]}
        mobileNavbar={[
          {title: "Magma v" + packageJson.version, click: about, icon: "alert-circle"},
          {title: "Change Password", click: showChangePassword, icon: "lock"},
          {title: "Change Configuration", click: showChangeConfiguration, icon: "lock"},
          {title: "Logout", click: logOut, icon: "log-out", logout: true},
        ]}
        loadNotifications={[]}
        role={getRole()}
        refs={getRefCount()}
        brand={brand}
      />
    </div>
  );
}
